import { useEffect, useMemo } from 'react';
import { StoreApi, UseBoundStore } from 'zustand';

import Repository, { RepositoryElement } from '../Repository';
import { KeysOfValue } from '../Utils';

export const createStoreListFieldHook =
  <Store>(useStore: UseBoundStore<StoreApi<Store>>) =>
  (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    repositoryName: KeysOfValue<Store, Repository<any>>,
    fieldName: string | undefined,
  ) => {
    const repository = useStore(
      (state) => state[repositoryName],
    ) as Repository<RepositoryElement>;

    const field = useMemo(
      () => (fieldName ? repository.list(fieldName) : undefined),
      [repository, fieldName],
    );

    useEffect(() => {
      if (field) {
        field.addListener();
        return () => {
          field.removeListener();
        };
      }
      return;
    }, [field]);

    return field;
  };

export const createStoreMapFieldHook =
  <Store>(useStore: UseBoundStore<StoreApi<Store>>) =>
  (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    repositoryName: KeysOfValue<Store, Repository<any>>,
    fieldName: string | undefined,
  ) => {
    const repository = useStore(
      (state) => state[repositoryName],
    ) as Repository<RepositoryElement>;

    const field = useMemo(
      () => (fieldName ? repository.map(fieldName) : undefined),
      [repository, fieldName],
    );

    useEffect(() => {
      if (field) {
        field.addListener();
        return () => {
          field.removeListener();
        };
      }
      return;
    }, [field]);

    return field;
  };
